// SPA entry point.
// -----------------------------------------------------------------
// Mounts the TanStack Router. M3.1 placeholder rendered <App />
// directly inside <MantineProvider>; M3.2 moves both providers
// (Mantine + Auth) into the router's __root.tsx so they wrap every
// route uniformly.
//
// Per dispatch m3-2-auth-rules-listener.md § 6.11.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  // Default not-found behaviour: bounce to /. /'s redirect handler
  // sends the user to /hello (or /login via the protected layout).
  defaultPreload: 'intent',
});

// Type-safety: register the router instance for TanStack's
// type-augmentation pattern.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
